<template>
  <div class='massLoss-list' v-loading='pageLoading'>
    <div class='nav'>
      <el-form :model='searchForm' label-width='110px' :inline='true'
               class='demo-form-inline flex1'>
        <el-form-item label='结算起止时间：'>
          <el-date-picker
            v-model='settlementTime'
            type='monthrange'
            style='width: 220px;'
            range-separator='-'
            size='mini'
            value-format='yyyy-MM'
            start-placeholder='开始日期'
            end-placeholder='结束日期' />
        </el-form-item>
        <el-form-item label='航次结束时间：'>
          <el-date-picker
            v-model='voyageTime'
            type='daterange'
            style='width: 220px;'
            range-separator='-'
            size='mini'
            value-format='yyyy-MM-dd'
            start-placeholder='开始日期'
            end-placeholder='结束日期' />
        </el-form-item>
        <el-form-item label='船名：'>
          <el-input v-model='searchForm.shipName' size='mini' placeholder='请输入船名' />
        </el-form-item>
        <el-form-item label='航次：'>
          <el-input v-model='searchForm.businessVoyage' size='mini' placeholder='请输入航次' />
        </el-form-item>
        <el-form-item label='锁定状态：'>
          <el-select v-model='searchForm.isLock' size='mini' filterable style='width:100%'
                     placeholder='请选择锁定状态' value-key='id'>
            <el-option v-for='item in lineOption' :key='item.value' :label='item.label'
                       :value='item.value' />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button size='small' class='searchBtn' @click='refreshReconciliation'>刷新对账</el-button>
          <el-button size='small' class='searchBtn' @click='searchBtn'>查询</el-button>
          <el-button size='small' class='resetBtn' @click='resetBtn'>重置</el-button>
          <el-button size='small' class='searchBtn' @click='addRemarks'>添加备注</el-button>
          <el-button size='small' class='searchBtn' @click='LockOrUnlock'>锁定/解锁</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-row>
      <el-col :span='24' style='text-align: end;font-size: 14px!important;' class='exportButton'>
        <span @click='exportData'>导出数据</span>
      </el-col>
    </el-row>
    <div class='content'>
      <div class='tableContainer'>
        <el-table
          ref='registerTable'
          row-key='id'
          v-loading='tableLoading'
          :data='tableData'
          style='width: 100%'
          :max-height='tableMaxHeight'
          border
          :header-cell-style='headerCellStyle'
          @select='handleCurrentChange'
          @select-all='handleCurrentChange'
          :row-style="rowStyle"
        >
          <el-table-column type='selection' align='center' width='50px' :reserve-selection='true' />
          <el-table-column prop='fleetName' label='业务公司' align='center' min-width='180px' />
          <el-table-column prop='settlementTime' label='结算月份' align='center' min-width='100' />
          <el-table-column prop='shipName' label='船名' align='center' min-width='180px' />
          <el-table-column prop='businessVoyage' label='业务航次' align='center' min-width='120' />
          <el-table-column label='上下水' align='center' min-width='80'>
            <template slot-scope='scope'>
              {{ scope.row.flowType === 1 ? '下水' : scope.row.flowType === 0 ? '上水' : '--' }}
            </template>
          </el-table-column>
          <el-table-column prop='voyageSailingTime' label='航次开航时间' align='center'
                           min-width='100' />
          <el-table-column prop='voyageEndTime' label='航次结束时间' align='center' min-width='100' />
          <el-table-column prop='portSailingTime' label='港口开航时间' align='center' min-width='100' />
          <el-table-column prop='riverTransportationStartPort' label='江运始港口' align='center'
                           min-width='100' />
          <el-table-column prop='riverTransportationEndPort' label='江运止港口' align='center'
                           min-width='100' />
          <el-table-column prop='departurePlace' label='起' align='center' min-width='200px' />
          <el-table-column prop='arrivePlace' label='止' align='center' min-width='200px' />
          <el-table-column label='货类' align='center' min-width='80'>
            <template slot-scope='scope'>
              {{
                scope.row.isNewEnergy === 1 ? '新能源' : scope.row.isNewEnergy === 0 ? '非新能源' : '--'
              }}
            </template>
          </el-table-column>
          <el-table-column prop='brandName' label='品牌' align='center' min-width='100' />
          <el-table-column prop='customerName' label='委托商' align='center' min-width='320' />
          <el-table-column prop='firstTransportationCount' label='船首运' align='center'
                           min-width='120' />
          <el-table-column prop='transportationCount' label='数量' align='center' min-width='120' />
          <el-table-column prop='unitPrice' label='单价' align='center' min-width='120' />
          <el-table-column prop='freight' label='运费' align='center' min-width='120' />
          <el-table-column prop='weight' label='重量' align='center' min-width='120' />
          <el-table-column prop='distance' label='里程' align='center' min-width='120' />
          <el-table-column prop='turnover' label='周转量' align='center' min-width='120' />
          <el-table-column label='锁定状态' align='center' min-width='100'>
            <template slot-scope='scope'>
              {{ scope.row.isLock === 1 ? '锁定' : scope.row.isLock === 0 ? '未锁定' : '--' }}
            </template>
          </el-table-column>
          <el-table-column prop='notes' label='备注' align='center' min-width='200'
                           show-overflow-tooltip />
          <el-table-column label='操作' align='center' min-width='220' fixed='right'>
            <template slot-scope='scope'>
              <el-button v-if='scope.row.isFree === 0' size='mini' class='searchBtn' type='primary'
                         @click='setFreeCar(scope.row.id)'>设为免费车
              </el-button>
              <el-button size='mini' class='searchBtn' type='primary'
                         @click='viewOperationRecords(scope.row.id)'>操作记录
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class='paginationContainer'>
        <el-pagination
          background
          :page-sizes='[500,750,1000]'
          layout='total, sizes, prev, pager, next, jumper'
          :total='total'
          @size-change='contractSizeChange'
          @current-change='contractCurrentChange'
          :current-page.sync='searchForm.page'
          :page-size='searchForm.rows'
        />
      </div>
    </div>

    <!-- 添加备注 -->
    <reconciliation-details-form ref='commercialCarPriceFormRef'
                                 @clearCheckTableData='clearCheckTableData' />

    <!-- 操作记录 -->
    <reconciliation-details-records ref='reconciliationDetailsRecordsRef' />
  </div>
</template>

<script>
  import {
    reconciliationDetailsList, reconciliationDetailsLock,
    reconciliationDetailsRefresh, updateForFree,
  } from '@/service/financial';
  import { getSessionStore } from '@/config/mUtils';
  import { baseUrl } from '@/config/env';
  import ReconciliationDetailsForm from './components/reconciliationDetailsForm.vue';
  import ReconciliationDetailsRecords
    from '@/views/financial/reconciliationDetails/components/reconciliationDetailsRecords';

  export default {
    name: 'reconciliationDetails',
    components: {
      ReconciliationDetailsRecords,
      ReconciliationDetailsForm,
    },
    data() {
      return {
        searchForm: {
          settlementStartTime: '',
          settlementEndTime: '',
          shipName: '',
          businessVoyage: '',
          isLock: '',
          voyageStartTime: '',
          voyageEndTime: '',
          page: 1,
          rows: 500,
        },
        settlementTime: ['', ''],
        voyageTime: ['', ''],
        defaultSearchForm: {},
        tableLoading: false,
        tableData: [],
        headerCellStyle: {
          'color': '#3B3B3B',
          'font-size': '13px',
          'height': '48px',
          'background': '#E8E8E8',
        },
        total: 0,
        lineOption: [{
          label: '全部',
          value: '',
        }, {
          label: '未锁定',
          value: '0',
        }, {
          label: '锁定',
          value: '1',
        }],
        pageLoading: false,
        checkTableData: [],
        windowHeight: 0,
        tableMaxHeight: 650,
      };
    },
    watch: {
      windowHeight() {
        this.getResolution(true);
      },
    },
    mounted() {
      this.getDefaultDate();
      this.defaultSearchForm = JSON.parse(JSON.stringify(this.searchForm));
      this.searchBtn();
      this.getResolution();
    },
    methods: {
      getResolution(flag) {
        if (flag) {
          this.windowHeight === 1080 ? this.tableMaxHeight = 650 : this.tableMaxHeight = 380;
          this.$forceUpdate();
          return;
        }
        this.windowHeight = window.screen.height;
      },
      // 查看操作记录
      viewOperationRecords(id) {
        this.$refs.reconciliationDetailsRecordsRef.dialogOpen(id);
      },
      // 设置免费车
      setFreeCar(id) {
        this.$confirm('确认设置当前车辆为免费车么？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            const res = await updateForFree({ id });
            if (res.status !== 0) return this.$message.error(res.message);
            this.$message.success(res.message);
            await this.getTableData();
          })
          .catch(() => {
          });
      },
      // 获取默认时间
      getDefaultDate() {
        const date = new Date();
        this.searchForm.settlementStartTime = this.searchForm.settlementEndTime = date.getFullYear() + '-' + (date.getMonth() + 1).toString()
          .padStart(2, '0');
        this.settlementTime = [this.searchForm.settlementStartTime, this.searchForm.settlementEndTime];
      },
      // 新增
      addRemarks() {
        if (this.checkTableData.length === 0) return this.$message.warning('请选择数据后添加备注');
        const ids = [];
        this.checkTableData.forEach(item => {
          ids.push(item.id);
        });
        this.$refs.commercialCarPriceFormRef.dialogOpen(ids);
      },
      // 锁定/解锁
      async LockOrUnlock() {
        if (this.checkTableData.length === 0) return this.$message.warning('请选择数据后锁定/解锁');
        const ids = [];
        this.checkTableData.forEach(item => {
          ids.push(item.id);
        });
        const {
          status,
          message,
        } = await reconciliationDetailsLock({ id: ids.join(',') });
        if (status !== 0) return this.$message.warning(message);
        this.$message.success(message);
        this.clearCheckTableData();
      },
      clearCheckTableData() {
        this.$refs.registerTable.clearSelection();
        this.checkTableData = [];
        this.getTableData();
      },
      // 刷新对账
      async refreshReconciliation() {
        this.pageLoading = true;
        const {
          status,
          message,
        } = await reconciliationDetailsRefresh();
        this.pageLoading = false;
        if (status !== 0) return this.$message.warning(message);
        this.$message.success(message);
        await this.getTableData();
      },
      // 导出数据
      exportData() {
        // let token = getSessionStore('token');
        // window.location.href = `${baseUrl}/platform/reconciliationDetails/export?access_token=${token}&settlementStartTime=${this.settlementTime ? this.settlementTime[0] : ''}&settlementEndTime=${this.settlementTime ? this.settlementTime[1] : ''}&shipName=${this.searchForm.shipName}&businessVoyage=${this.searchForm.businessVoyage}&isLock=${this.searchForm.isLock}&voyageStartTime=${this.voyageTime ? this.voyageTime[0] : ''}&voyageEndTime=${this.voyageTime ? this.voyageTime[1] : ''}`;
        window.exportExcelGet('/platform/reconciliationDetails/export', `settlementStartTime=${this.settlementTime ? this.settlementTime[0] : ''}&settlementEndTime=${this.settlementTime ? this.settlementTime[1] : ''}&shipName=${this.searchForm.shipName}&businessVoyage=${this.searchForm.businessVoyage}&isLock=${this.searchForm.isLock}&voyageStartTime=${this.voyageTime ? this.voyageTime[0] : ''}&voyageEndTime=${this.voyageTime ? this.voyageTime[1] : ''}`)
      },
      // 查询
      searchBtn() {
        this.searchForm.page = 1;
        this.getTableData();
      },
      // 重置
      resetBtn() {
        this.searchForm = JSON.parse(JSON.stringify(this.defaultSearchForm));
        this.settlementTime = [this.searchForm.settlementStartTime, this.searchForm.settlementEndTime];
        this.voyageTime = [this.searchForm.voyageStartTime, this.searchForm.voyageEndTime];
      },
      // 获取表格数据
      async getTableData() {
        this.tableLoading = true;
        await reconciliationDetailsList({
          ...this.searchForm,
          settlementStartTime: this.settlementTime ? this.settlementTime[0] : '',
          settlementEndTime: this.settlementTime ? this.settlementTime[1] : '',
          voyageStartTime: this.voyageTime ? this.voyageTime[0] : '',
          voyageEndTime: this.voyageTime ? this.voyageTime[1] : '',
        })
          .then(res => {
            this.tableLoading = false;
            if (res.status !== 0) return this.$message.warning(res.message);
            this.tableData = res.data.records;
            this.total = res.data.total;
          })
          .catch(() => {
            this.tableLoading = false;
            this.$message.warning('请求超时');
          });
      },
      contractSizeChange(row) {
        this.searchForm.rows = row;
        this.searchForm.page = 1;
        this.getTableData();
      },
      contractCurrentChange(page) {
        this.searchForm.page = page;
        this.getTableData();
      },
      // 多选事件触发
      handleCurrentChange(val) {
        this.checkTableData = val;
      },
      rowStyle({ row }) {
        return this.checkTableData.includes(row) ? { background: 'rgb(197 226 255)' } : {};
      },
    },
  };
</script>


<style lang='scss' scoped>
  .massLoss-list {
    /*width:100%;*/
    padding: 20px 15px 0 25px;
    height: 100%;
    /*overflow: auto;*/
    .nav {
      /*width:100%;*/
      display: flex;
      /*align-items: center;*/
      /*height:30px;*/
      overflow: hidden;

      .flex1 {
        flex: 1;
      }

      .el-input {
        width: 150px;
      }

      .el-select {
        width: 150px;
      }

      ::v-deep {
        label.el-form-item__label {
          font-weight: 500;
          color: #101010;
        }
      }
    }

    ::v-deep .detail {
      width: 100%;
      padding: 10px 0 20px 20px;

      .el-form-item {
        margin-bottom: 2px;

        .el-form-item__label {
          /*color: #060606;*/
          font-weight: 700;
        }
      }

      .line {
        width: 12px;
        height: 32px;
        background-color: rgba(51, 84, 131, 100);
        margin-right: 10px;
      }

      .line + span {
        font-size: 16px;
        color: rgba(51, 84, 131, 100);
        font-weight: 600;
      }

      .baseInfo {
        display: flex;
        flex-direction: column;

        &Title {
          display: flex;
          align-items: flex-end;

          p {
            font-weight: 700;
            font-size: 14px;
            color: rgba(249, 166, 6);
            margin-left: 10px;
          }
        }

        &Content {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 20px 23px 0 23px;
          font-size: 14px;

          .center-f {
            display: flex;
          }
        }
      }
    }


    ::v-deep .add {
      width: 100%;

      .el-form-item__label {
        font-weight: 700;
      }

      .baseInfo {
        display: flex;
        flex-direction: column;

        &Content {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 20px 23px 0 23px;
          font-size: 14px;

          .center-f {
            display: flex;
          }

          .yang {
            .el-form-item {
              .el-form-item__error {
                left: 40px;
              }

              margin-bottom: 5px;

              .el-form-item__label {
                // width: 150px !important;
                /*color: #060606;*/
              }

            }

          }

          .repair {
            .el-input {
              width: 80%;
            }

            .el-form-item {
              .el-form-item__error {
                /*left: 41px;*/
                padding-top: 0px;
              }

              margin-bottom: 7px;

              .el-form-item__label {
                /*width: 155px  !important;*/
                /*color: #060606;*/
              }
            }

            .el-upload-list__item {
              width: 100px;
              height: 100px;
            }

            .el-upload--picture-card {
              width: 100px;
              height: 100px;
              line-height: 100px;
            }

            /*display: none;*/
            .imgUp {
              display: flex;
              flex-direction: column;

              .imgLength {
                display: flex;
                align-items: center;
                width: 100%;

                span {
                  margin-left: auto;
                  color: rgb(183, 183, 183);
                  font-size: 16px;
                }
              }
            }
          }

        }
      }

      .btnContainer {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 13px;
        margin-top: 20px;

        button {
          margin: 0 15px;
        }
      }
    }

    ::v-deep {

      .el-dialog__header {
        padding: 9px 20px 9px;
        background: #335483;
      }

      .el-dialog__title {
        line-height: 24px;
        font-size: 14px;
        color: #FFFFFF;
      }

      .el-dialog__headerbtn {
        top: 9px;
      }

      .el-dialog__headerbtn .el-dialog__close {
        color: #fff;
        font-size: 25px;
      }

      .el-dialog__body {
        padding: 0;
        overflow: auto;
        max-height: 75vh;
        color: #606266;
      }

      .el-form--inline .el-form-item {
        margin-bottom: 5px;
      }

    }

  }

  .tableContainer {
    margin: 10px 0 30px 0;
  }

  .exportButton {
    span {
      color: rgba(51, 136, 255, 1);
      margin-right: 10px;
      font-size: 14px;

      &:hover {
        cursor: pointer;
      }
    }
  }
</style>
